import { initLogTransport } from '@config/logging/log-transport'
import ReactDOM from 'react-dom/client'

import { App } from './app'

initLogTransport()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
